import TokenProvider from '../../commons/providers/token-provider';
import ValidarProvider from '../providers/validar-provider';

class ValidarRepository {
  constructor() {
    this.validarProvider = new ValidarProvider();
    this.tokenProvider = new TokenProvider();
  }

  postValidarCreatePersona = async (datosPersona) => {
    await this.tokenProvider.getToken();
    return this.validarProvider.postValidarCreatePersona(datosPersona);
  };
}

const validarRepositoryInstance = new ValidarRepository();

export default validarRepositoryInstance;
